import { BookOpen } from "lucide-react";

const poles = [
  {
    code: "F1",
    titre: "Exploitation des unités de traitement et des réseaux",
    activites: ["Organisation et coordination", "Pilotage", "Maintenance"],
    unite: "Unité U5 — épreuve E5 (coefficient 9)",
    resume: "Mesures et analyses de suivi, adaptation du traitement à la qualité de l'eau, pilotage et maintenance des installations et des réseaux.",
  },
  {
    code: "F2",
    titre: "Qualité, sécurité, environnement",
    activites: ["Qualité", "Santé, hygiène et sécurité", "Environnement et risques industriels"],
    unite: "Unité U6 — épreuve E6 (coefficient 4)",
    resume: "Conformité réglementaire (potabilité, rejet), démarche qualité et prévention des risques professionnels et environnementaux.",
  },
  {
    code: "F3",
    titre: "Relations professionnelles et encadrement d'équipes",
    activites: ["Relation avec les décideurs", "Animation des équipes opérationnelles", "Gestion du développement des compétences", "Communication interne et externe"],
    unite: "Unité U7 — épreuve E7 (coefficient 3)",
    resume: "Identifier les acteurs de l'eau, rendre compte aux décideurs, animer une équipe opérationnelle et développer les compétences.",
  },
  {
    code: "F4",
    titre: "Conception des unités de traitement et des réseaux",
    activites: ["Dimensionnement et choix des procédés (dans le cadre d'un budget)", "Représentation graphique des installations"],
    unite: "Unité U8 — épreuve E8 (coefficient 4)",
    resume: "Analyser les besoins de prestation, concevoir et dimensionner les unités de traitement et les réseaux.",
  },
];

export default function FonctionsReferentiel() {
  return (
    <section className="space-y-5" data-testid="fonctions-referentiel-view">
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#002FA7]" data-testid="fonctions-kicker">Référentiel — session 2027</p>
        <h2 className="mt-2 font-display text-3xl font-bold" data-testid="fonctions-title">Les fonctions F1 à F4 du BTS Métiers de l'eau</h2>
        <p className="mt-2 max-w-3xl text-zinc-600" data-testid="fonctions-intro">Les quatre fonctions structurent les activités professionnelles du diplôme (arrêté du 8 juillet 2024, session 2027). Pour les équipes pédagogiques comme pour les tuteurs : elles situent les missions confiées à l'étudiant en entreprise.</p>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        {poles.map((pole) => (
          <article key={pole.code} className="border border-zinc-200 bg-white p-5" data-testid={`fonction-card-${pole.code.toLowerCase()}`}>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center bg-[#002FA7] font-display text-lg font-bold text-white" data-testid={`fonction-code-${pole.code.toLowerCase()}`}>{pole.code}</span>
              <h3 className="font-display text-xl font-bold" data-testid={`fonction-titre-${pole.code.toLowerCase()}`}>{pole.titre}</h3>
            </div>
            <p className="mt-3 text-sm text-zinc-600" data-testid={`fonction-resume-${pole.code.toLowerCase()}`}>{pole.resume}</p>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.18em] text-zinc-500" data-testid={`fonction-activites-titre-${pole.code.toLowerCase()}`}>Activités principales</p>
            <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-zinc-700" data-testid={`fonction-activites-${pole.code.toLowerCase()}`}>
              {pole.activites.map((activite) => <li key={activite}>{activite}</li>)}
            </ul>
            <p className="mt-4 border-t pt-3 text-sm font-semibold text-[#002FA7]" data-testid={`fonction-unite-${pole.code.toLowerCase()}`}>{pole.unite}</p>
          </article>
        ))}
      </div>

      <div className="flex items-start gap-3 border border-zinc-200 bg-zinc-50 p-4 text-sm text-zinc-600" data-testid="fonctions-source">
        <BookOpen className="mt-0.5 h-5 w-5 shrink-0 text-[#002FA7]" aria-hidden="true" />
        <p>Source : arrêté du 8 juillet 2024 portant définition et fixant les conditions de délivrance du brevet de technicien supérieur « métiers de l'eau » (NOR ESRS2414670A — <a className="font-semibold text-[#002FA7]" href="https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000049926700" target="_blank" rel="noreferrer">texte officiel sur Légifrance</a>) — application à la session 2027. Résumé à titre informatif ; les libellés complets figurent dans les annexes du référentiel.</p>
      </div>
    </section>
  );
}
